/* lp-kit.js · gemeinsames Verhalten der lp-Sections (Stand 03.11.2026)
   1. Kaufknöpfe [data-lp-buy]: Modus "checkout" = Cart-Permalink /cart/<id>:<menge> (direkt in die Kasse),
      Modus "cart" = /cart/add.js, danach /cart. utm_*, fbclid, gclid, ttclid der Seite werden angehängt.
   2. Wisch-Reihen [data-lp-scroller] mit Punkten [data-lp-dots] (optional).
   3. Ankerknöpfe ruhig scrollen (prefers-reduced-motion beachtet, CSS übernimmt).
   Läuft mehrfach geladen nur einmal (window.__lpKit). Neu initialisieren im Theme-Editor über shopify:section:load. */
(function () {
  if (window.__lpKit) return;
  window.__lpKit = true;

  var KEEP = /^(utm_[a-z]+|fbclid|gclid|ttclid|msclkid|ref)$/i;
  function trackingParams() {
    var out = [];
    try {
      new URLSearchParams(location.search).forEach(function (v, k) { if (KEEP.test(k)) out.push([k, v]); });
    } catch (e) {}
    return out;
  }
  function withParams(href) {
    var p = trackingParams();
    if (!p.length) return href;
    try {
      var u = new URL(href, location.origin);
      p.forEach(function (kv) { if (!u.searchParams.has(kv[0])) u.searchParams.set(kv[0], kv[1]); });
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }

  function initBuy(root) {
    (root || document).querySelectorAll('a[data-lp-buy]').forEach(function (a) {
      if (a.__lpBuy) return;
      a.__lpBuy = true;
      var mode = a.getAttribute('data-lp-mode') || 'checkout';
      if (mode === 'checkout') {
        a.setAttribute('href', withParams(a.getAttribute('href')));
        return;
      }
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('data-variant-id');
        if (!id) return;
        ev.preventDefault();
        a.setAttribute('data-lp-busy', '');
        var qty = parseInt(a.getAttribute('data-qty') || '1', 10) || 1;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart ' + r.status);
          location.href = withParams('/cart');
        }).catch(function () {
          a.removeAttribute('data-lp-busy');
          location.href = withParams('/cart/' + id + ':' + qty);
        });
      });
    });
  }

  function initScrollers(root) {
    (root || document).querySelectorAll('[data-lp-scroller]').forEach(function (sc) {
      if (sc.__lpSc) return;
      sc.__lpSc = true;
      var dots = sc.parentNode.querySelector('[data-lp-dots]');
      if (!dots) return;
      var items = Array.prototype.slice.call(sc.children);
      dots.innerHTML = '';
      items.forEach(function (it, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Zu Element ' + (i + 1));
        b.addEventListener('click', function () { sc.scrollTo({ left: it.offsetLeft - sc.offsetLeft, behavior: 'smooth' }); });
        dots.appendChild(b);
      });
      function upd() {
        var x = sc.scrollLeft, best = 0, d = 1e9;
        items.forEach(function (it, i) { var dd = Math.abs(it.offsetLeft - sc.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
        Array.prototype.forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
      }
      sc.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  function init(root) { initBuy(root); initScrollers(root); }
  window.lpKit = { init: init, withParams: withParams };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
